import { getLocalJSON } from '../utils/requester'

// Initializes LanguageManager.
export class LanguageManager {

  init = (callback, isElectron) =>{
  	this.isElectron = isElectron;
  	this.callbackLang = callback;

    var languageStored = "en";
    try{
      languageStored = localStorage.getItem( 'flipwitLang');
    }
    catch(e){console.log("Error getting localStorage")}
  	
    console.DEBUG_FLIPWIT('languageStored ' + languageStored)

    var langApp = "en";
    if( languageStored ){
      langApp = languageStored;
    }
    else{
      var userLang = navigator.languages && navigator.languages.length > 0? navigator.languages[0] : (navigator.language || navigator.userLanguage);
      if (userLang.indexOf('-') !== -1)
          userLang = userLang.split('-')[0];

      if (userLang.indexOf('_') !== -1)
          userLang = userLang.split('_')[0];
      
      userLang = userLang.toLowerCase();

      if( userLang === "es"){
        langApp = "es";
      }
    }

    try{
      localStorage.setItem( 'flipwitLang', langApp);
    }
    catch(e){console.log("Error setting localStorage")}

    console.log('Intenta leer JSON');
    getLocalJSON( "./langs/" + langApp + "2.json", this.jsonLoaded, isElectron, this.jsonError);
  }

  jsonLoaded = ( jsonData ) => {
    this.texts = jsonData.TEXTS;
    this.titles = jsonData.TITLES;
    this.callbackLang( jsonData );
  }

  jsonError = ( error ) =>{
  	if( this.isElectron ){
  		getLocalJSON( "https://app.flipwit.com/langs/" + localStorage.getItem( 'flipwitLang') + "2.json", this.jsonLoaded, false, null);
  	}
  }

  changeLanguage = (lang, callback) => {
  	this.callbackLang = callback;
    console.log('cambie language a ' + lang)
    try{
      localStorage.setItem( 'flipwitLang', lang);
    }catch(e){console.log("Error setting localStorage")}

    getLocalJSON( "./langs/" + lang + "2.json", this.jsonLoaded, this.isElectron, this.jsonError);
  }
 
  getLangWord= ( word ) =>{
    try{
      return this.texts[word];      
    }
    catch(e) {
      return "NO_LANG_DATA";
    }
  }

  getLangTitle = ( title ) =>{
    console.log(this)
    console.log(this.titles[title])
    try{
  	 return this.titles[title];
    }
    catch(e) {
      return "NO_LANG_DATA";
    }
  }


}

export let languageManager = new LanguageManager();



// WEBPACK FOOTER //
// ./src/containers/utils/languageManager.js